"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Pulled directly from Propulsion Colors
 */
var STAINLESS_500 = '#c8cfd4';
var MONO_500 = '#b6bec4';
var SPOON_500 = '#95a1a6';
var colors = {
  light: STAINLESS_500,
  medium: MONO_500,
  dark: SPOON_500
};

var Divider = function Divider(_ref) {
  var kind = _ref.kind,
      style = _ref.style,
      restOfProps = _objectWithoutProperties(_ref, ["kind", "style"]);

  /**
   * Initial styles for a "hr" element
   */
  var defaultStyles = {
    display: 'block',
    height: 1,
    padding: 0
  };

  var styles = _objectSpread({}, defaultStyles, {
    border: 'initial',
    borderTop: "1px solid ".concat(colors[kind]),
    margin: 0
  }, style);

  return _react.default.createElement("hr", _extends({}, restOfProps, {
    style: styles
  }));
};

Divider.propTypes = {
  /** The variant of the Divider. */
  kind: (0, _propTypes.oneOf)(['light', 'medium', 'dark']),

  /** Object with CSS style properties to apply to component inline. */
  style: (0, _propTypes.shape)()
};
Divider.defaultProps = {
  kind: 'light',
  style: null
};
var _default = Divider;
exports.default = _default;
